const INITIAL_STATE = {
  data: [],
};

const loadManufacturingOrderReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "ADD_MANU":
      return {
        ...state.data,
        data: action.manufacturingOrder,
      };
    case "CHANGE_DESING":
      return {
        ...state,
        data: [
          ...state.data.map((d) =>
            d.id_manufacturing_order === action.manufacturingOrder.id_manufacturing_order ? action.manufacturingOrder : d
          ),
        ],
      };
    //return { ...state, data: [...state.data, action.manufacturingOrder] };
    case "UPDATE_PIECE_STATUS":
      return {
        ...state,
        data: [
          ...state.data.map((d) =>
            d.id_manufacturing_order === action.manufacturingOrder.id_manufacturing_order ? action.manufacturingOrder.pieces : d.pieces
          ),
        ],
      };
    default:
      return state;
  }
};

export default loadManufacturingOrderReducer;
